// Components
import { BreadCrumb, TerminalTab } from '../../components';

// Libraries
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

const CreateTerminal = ({ history }) => {
    const { location } = history;

    useEffect(() => {
        if (location.pathname !== '/tid-onboarding/create/terminal') {
            history.replace('/tid-onboarding');
        }
    }, [history, location.pathname]);

    return (
        <div className="create-merchant-wrap" id="create-merchant-section">
            <div className="bread-crumbs">
                <h3>Create Terminal ID</h3>
                <BreadCrumb
                    breadCrumbs={[
                        {
                            name: 'Terminal ID Onboarding',
                            link: '/tid-onboarding',
                        },
                        {
                            name: 'Create Terminal ID',
                            link: '',
                        },
                    ]}
                />
            </div>
            <div className="create-merchant">
                <TerminalTab />
            </div>
        </div>
    );
};

CreateTerminal.propTypes = {
    history: PropTypes.object,
};

export default CreateTerminal;
